import React from "react";
import { Fade } from "react-reveal";
import offer1 from "../../../images/offer_icon/offer1.png";
import offer2 from "../../../images/offer_icon/offer2.png";
import offer3 from "../../../images/offer_icon/offer3.png";
import headerBg from "../../../images/header-bg.png";
import "./Offer.css";

const Offer = () => {
  return (
    <div className="whatOffer">
      <div className="container">
        <div className="main_title">
          <Fade left>
            <h1 className="sectionHeader111 py-3">
              <span className="text-yellow">What</span>
              <span className="text-blue">
                {" "}
                we offer{" "}
                <span className="headerPsudo222">
                  <img src={headerBg} alt="" />
                </span>
              </span>
            </h1>
          </Fade>
        </div>
        {/* <div className="offer_title pb-2 pt-4">
          <h1>
            <span className="text-yellow">What</span> we offer
          </h1>
        </div> */}
        <div className="row">
          <div className="col-md-12 col-lg-4 text-center">
            <div className="service">
              <div className="service_icon pt-1">
                <img src={offer3} alt="" />
              </div>
              <div className="service_text pt-3">
                <h4 className="offer_sub_title">Guaranteed Payment</h4>
                <p className="offer_p text-secondary pt-2">
                  Our platform gives you the peace of mind of a secure a
                  guaranteed payment, with insurance and cancelation polices.
                </p>
              </div>
            </div>
          </div>
          <div className="col-md-12 col-lg-4 text-center">
            <div className="service pt-2">
              <div className="service_icon">
                <img src={offer2} alt="" />
              </div>
              <div className="service_text py-3">
                <h4 className="offer_sub_title">Verified customers</h4>
                <p className="offer_p text-secondary pt-1">
                  All our users are verified customers. We Share, is a safe
                  place to rent your items. We take safety and the quality of
                  our service seriously.
                </p>
              </div>
            </div>
          </div>
          <div className="col-md-12 col-lg-4 text-center">
            <div className="service">
              <div className="service_icon pt-2">
                <img src={offer1} alt="" />
              </div>
              <div className="service_text text-center py-3">
                <h4 className="offer_sub_title">
                  Community and lots of choices
                </h4>
                <p className="offer_p text-secondary pt-1">
                  Community is our strength! We help you connect with people
                  nearby and from around the world. That’s how we do more for
                  less.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Offer;
